import { render, staticRenderFns } from "./dataBox3.vue?vue&type=template&id=b2b2ec66&scoped=true&"
import script from "./dataBox3.vue?vue&type=script&lang=ts&"
export * from "./dataBox3.vue?vue&type=script&lang=ts&"
import style0 from "./dataBox3.vue?vue&type=style&index=0&id=b2b2ec66&scoped=true&lang=scss&"
import style1 from "./dataBox3.vue?vue&type=style&index=1&id=b2b2ec66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b2ec66",
  null
  
)

export default component.exports